import styled from 'styled-components'

export default styled.div `

    .title {
        text-align: left;
    }
    .author-date {
        padding: 0 1.5625rem;
        background: ${props => props.theme.colors.blue10};
        p {
            margin: 0;
        }
    }
    .title-caption {
        padding: 0 1.5625rem;
        background: ${props => props.theme.colors.blue10};
    }

    .copy-brief {
        padding: 1rem 1.5625rem 0;
    }
    .bUyIod {
        padding: 0;
    }
` 